export default __webpack_public_path__ + "static/media/_Arte_Escena_305_Y_503.87318e0d.png";